import { gearsRobotsTxtLoader as Ne } from "./lib.gears-robots-txt.es.js";
import { gearsSitemapIndexLoader as Me } from "./lib.gears-sitemap-index.es.js";
import { gearsSitemapLoader as He } from "./lib.gears-sitemap.es.js";
import { gearsStatusLoader as ze } from "./lib.gears-status.es.js";
import { useLocation as Y, useRouteLoaderData as j, createCookie as ee, redirect as te, data as oe } from "react-router";
import { useState as ne, useEffect as ae } from "react";
import { fetchPage as re, fetchSettingsAndContent as se } from "@made-people/gears-bff-client";
import { shouldHandleUrl as W, normalizeSlug as ie } from "@made-people/gears-utils";
import { toGearsEnvironmentOrUndefined as ce, getGearsConfigurationVariable as w, toGearsDomainOrUndefined as le, toGearsRunModeOrUndefined as de, toGearsLocalServicesOrUndefined as pe, toGearsClusterModeOrUndefined as ue } from "@made-people/gears-configuration";
import { isStoryblokPreviewRequestQuery as fe } from "@made-people/gears-storyblok";
const xe = () => Y(), De = () => {
  const t = j("root");
  if (t !== null)
    return t;
}, Ue = (t) => {
  const o = Y(), [n, e] = ne("");
  ae(() => {
    n !== o.pathname && (t(), e(o.pathname));
  }, [n, o.pathname]);
};
function B(t) {
  const o = {};
  return Object.keys(t).forEach((n) => {
    const e = n.indexOf("[");
    if (e !== -1) {
      const c = n.substring(0, e), l = n.substring(e + 1, n.length - 1);
      o[c] || (o[c] = {}), o[c][l] = t[n];
    } else
      o[n] = t[n];
  }), o;
}
const me = (t) => {
  const o = {};
  for (const [n, e] of t)
    o[n] = e;
  return o;
};
async function ge(t) {
  let o = {};
  try {
    const n = await t.formData();
    let e = {};
    for (const [s, r] of n.entries())
      typeof r == "string" && (e[s] = r);
    o = B(e);
    const c = me(
      new URLSearchParams(t.url.split("?")[1])
    ), l = B(c);
    Object.assign(o, l);
  } catch {
  }
  return o;
}
const ve = (t) => t.split(";").map((o) => o.split("=")).reduce(
  (o, n) => (n[0] && n[1] && (o[decodeURIComponent(n[0].trim())] = decodeURIComponent(
    n[1].trim()
  )), o),
  {}
);
async function Ee({ request: t }) {
  return {
    paymentMethodFields: await ge(
      // see https://github.com/remix-run/remix/pull/8062 for why we need to cast this
      t
    )
  };
}
const Q = "x-campaign-site-key", he = async (t, o) => {
  var p;
  const n = new URL(t.request.url);
  if (!W(n))
    throw new Response("404 /build/ should not be served by me", {
      status: 404
    });
  const e = ee(Q, {
    maxAge: 604800
    // one week
  }), c = t.request.headers.get("Cookie"), l = await e.parse(c);
  l && t.request.headers.set(Q, l);
  const s = await re(n, t.request.headers);
  if (!s)
    throw new Response("Service Unavailable", {
      status: 500
    });
  const { page: r } = s;
  switch (r.pageType) {
    case "rawResponse":
      throw new Response(r.content, {
        status: r.statusCode,
        headers: {
          "content-type": r.contentType
        }
      });
    case "redirect":
      throw te(r.location, r.statusCode);
  }
  const d = new Headers();
  return s.frontendContext.campaignSite ? d.set(
    "Set-Cookie",
    await e.serialize(
      s.frontendContext.campaignSite.key
    )
  ) : typeof l == "string" && !s.frontendContext.campaignSite && d.set(
    "Set-Cookie",
    await e.serialize("", {
      maxAge: 0,
      expires: /* @__PURE__ */ new Date(0)
    })
  ), (p = r == null ? void 0 : r.headers) != null && p["cache-control"] && d.set("Cache-Control", r.headers["cache-control"]), o ?? (o = {}), {
    loaderData: { pageResponse: s, customExtraData: o },
    responseInit: {
      status: r.statusCode,
      headers: d
    }
  };
};
function _e(t) {
  return oe(t.loaderData, t.responseInit);
}
const Te = async (t, o) => _e(
  await he(t, o)
), we = (t) => typeof t == "object" && t !== null, ye = (t) => typeof t == "object" && t !== null, Ie = ({
  loaderData: t,
  matches: o
}) => {
  var E, T, I, $, P, A, N, G, M, q, H, O, z, F, K;
  const n = we(t) ? t.pageResponse : void 0, e = n == null ? void 0 : n.page;
  if (!e || !e.pageType || e.pageType === "rawResponse" || e.pageType === "redirect")
    return [];
  const c = o.find((a) => a.id === "root"), l = c == null ? void 0 : c.loaderData, s = ye(
    l
  ) ? l.settingsAndContentResponse : void 0, r = s == null ? void 0 : s.frontendContext;
  let d = "";
  r ? d = r.baseUrl : console.warn(
    "Didn't receive frontendContext in settingsAndContentResponse, cannot resolve baseURL"
  );
  const p = (E = s == null ? void 0 : s.globalStoryblokStories) == null ? void 0 : E.find(
    (a) => a.lookupConfiguration.lookupType === "slug" && a.lookupConfiguration.slug === "shared-content/settings/general"
  );
  p != null && p.content[0] || console.warn(
    "No SB general settings were found, default meta data from SB cannot be used"
  );
  const {
    default_meta_description: i,
    checkout_meta_title: S,
    checkout_success_meta_title: k,
    search_page_meta_title: C,
    account_page_meta_title: b,
    account_login_meta_title: L,
    restore_password_meta_title: x,
    pdp_meta_title_suffix: X,
    pdp_meta_title_prefix: Z,
    meta_title_suffix: D,
    meta_title_prefix: U,
    openGraphImage: y
  } = ((T = p == null ? void 0 : p.content) == null ? void 0 : T[0]) || {}, m = [];
  let _ = (y == null ? void 0 : y.filename) || "", u, f, g, h;
  switch (e.pageType) {
    case "checkoutIndex":
    case "checkoutFinalize":
      u = S || "", f = i || "", g = S || "", h = i || "";
      break;
    case "searchPage":
      u = C || "", f = i || "", g = C || "", h = i || "";
      break;
    case "accountIndex":
      u = b || "", f = i || "", g = b || "", h = i || "";
      break;
    case "accountLogin":
      u = L || "", f = i || "", g = L || "", h = i || "";
      break;
    case "forgotPassword":
      u = x || "", f = i || "", g = x || "", h = i || "";
      break;
    case "checkoutReceipt":
      u = k || "", f = i || "", g = k || "", h = i || "";
      break;
    case "centraProductPage":
      u = `${Z || ""}${((I = e.meta) == null ? void 0 : I.title) || ""}${X || ""}`, f = (($ = e.meta) == null ? void 0 : $.description) || "", g = (P = e.meta) == null ? void 0 : P.title, h = (A = e.meta) == null ? void 0 : A.description, _ = ((N = e.productData) == null ? void 0 : N.mediaUrls.length) && e.productData.mediaUrls[0] || _;
      break;
    case "storyblokPage":
      const a = (M = (G = e.storyblokData) == null ? void 0 : G.content) == null ? void 0 : M.seo, J = (a == null ? void 0 : a.title) || ((q = e.meta) == null ? void 0 : q.title) || "", V = (a == null ? void 0 : a.description) || i || ((H = e.meta) == null ? void 0 : H.description) || "";
      u = `${U || ""}${J}${D || ""}`, f = V || (a == null ? void 0 : a.og_description), g = (a == null ? void 0 : a.og_title) || J, h = (a == null ? void 0 : a.og_description) || V, _ = (a == null ? void 0 : a.og_image) || _;
      break;
    default:
      u = `${U || ""}${((O = e.meta) == null ? void 0 : O.title) || ""}${D || ""}`, f = ((z = e.meta) == null ? void 0 : z.description) || "", h = (F = e.meta) == null ? void 0 : F.description, g = (K = e.meta) == null ? void 0 : K.title;
      break;
  }
  m.push({ title: u }), m.push({ name: "description", content: f }), m.push({ property: "og:title", content: g || u }), m.push({
    property: "og:url",
    content: `${d}${e.meta.canonicalUrl}`
  }), m.push({
    property: "og:description",
    content: h || f
  }), _ && m.push({ property: "og:image", content: _ }), e.meta.canonicalUrl && m.push({
    tagName: "link",
    rel: "canonical",
    href: `${d}${e.meta.canonicalUrl}`
  });
  for (const a of e.meta.hreflangLocales)
    m.push({
      tagName: "link",
      rel: "alternate",
      hrefLang: a.hreflang,
      href: `${d}${a.url}`
    });
  const R = [];
  e.meta.noIndex && R.push("noindex"), e.meta.noFollow && R.push("nofollow");
  const v = R.join(",");
  return v && m.push({ name: "robots", content: v }), m;
}, $e = async (t) => {
  const o = new URL(t.request.url);
  o.pathname = ie(o.pathname);
  const [, n] = o.pathname.split("/");
  if (!W(o) || n === "" || n === void 0)
    return null;
  const e = await se(
    n,
    t.request.headers
  );
  if (!e)
    return null;
  const c = ce(
    w("gearsEnvironment")
  );
  if (typeof c > "u")
    throw new Error("GEARS_ENVIRONMENT variable isn't set.");
  const l = w("tenantId");
  if (typeof l > "u")
    throw new Error("TENANT_ID variable isn't set.");
  const s = le(
    w("gearsDomain")
  ), r = de(
    w("gearsRunMode")
  ), d = pe(
    w("localServices")
  ), p = ue(
    w("gearsClusterMode")
  ), i = !!process.env.JOTAI_DEVTOOLS;
  return {
    settingsAndContentResponse: e,
    insideStoryblokPreview: fe(
      Object.fromEntries(o.searchParams.entries())
    ),
    gearsConfiguration: {
      tenantId: l,
      gearsEnvironment: c,
      localServices: d,
      gearsRunMode: r,
      gearsClusterMode: p,
      gearsDomain: s
    },
    jotaiDevtoolsEnabled: i
  };
};
export {
  ge as convertPostAndGetToJSON,
  _e as createGearsLoaderResponse,
  Ee as gearsAction,
  Te as gearsLoader,
  Ie as gearsMeta,
  Ne as gearsRobotsTxtLoader,
  $e as gearsRootLoader,
  Me as gearsSitemapIndexLoader,
  He as gearsSitemapLoader,
  ze as gearsStatusLoader,
  ve as parseCookie,
  he as resolveGearsResult,
  B as toJSON,
  xe as useLocation,
  De as useRootLoaderData,
  Ue as useRouteChanged
};
//# sourceMappingURL=lib.index.es.js.map
